/**
 * Parses a Sprite2D: the Node2D surface plus the textured-quad surface. Godot's
 * defaults: centered = true, hframes = vframes = 1, modulate = white.
 */
import { parseNode2D } from '../../base/node2d/parser';
import { boolOr, parseOptionalRect2, vec2Or } from '../../../parser/valueParsers';
import { holdsResource } from '../../../godot/scene/resourceLiteral.js';
import { frameCoords, replaySpriteFrames } from '../../../godot/scene/spriteFrames.js';
export function parseSprite2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    const frames = replaySpriteFrames(properties);
    const result = {
        ...base,
        centered: boolOr(properties.centered, true),
        offset: vec2Or(properties.offset, { x: 0, y: 0 }, 'Sprite2D'),
        flip_h: boolOr(properties.flip_h, false),
        flip_v: boolOr(properties.flip_v, false),
        region_enabled: boolOr(properties.region_enabled, false),
        // The grid and frame Godot holds after replaying the body in file order: a
        // refused `frame` stays 0, and a later `hframes` re-maps one that landed
        // (godot/scene/spriteFrames.ts).
        hframes: frames.hframes,
        vframes: frames.vframes,
        frame: frames.frame,
    };
    if (holdsResource(properties.texture))
        result.texture = properties.texture;
    // Kept as the stored frame's own coordinates: the renderer prefers this
    // field, and the authored pair may have been refused or re-mapped.
    if (frames.writes.some((w) => w.key === 'frame_coords'))
        result.frame_coords = frameCoords(frames);
    if (properties.region_rect) {
        const r = parseOptionalRect2(properties.region_rect, 'Sprite2D region_rect');
        if (r)
            result.region_rect = r;
    }
    return result;
}
//# sourceMappingURL=parser.js.map